import Anchor from '@restart/ui/Anchor';
export default Anchor;